import { AnyAction } from "@reduxjs/toolkit";
import { produce } from "immer";

import { ITeamMember } from "../../myTeam/reducers";
import { IReferential } from "../../referential/reducers";
import {
  GET_USER_SUCCESS,
  SET_IS_LOGGED_FALSE,
  SET_IS_LOGGED_TRUE,
  TOGGLE_CREATE_COMPANY_SUCCESS,
  TOGGLE_LOGIN,
  TOGGLE_LOGIN_FAILED,
  TOGGLE_LOGIN_SUCCESS,
  TOGGLE_LOGOUT_SUCCESS,
  TOGGLE_REGISTER_SUCCESS,
  TOKEN_IS_VALID_FAILED,
} from "../constants";

// export interface IAuthState {
//   isLogged: boolean;
//   user: IUserState | null;
//   token: string | null;
//   company: ICompanyState | null;
// }

export interface IUserCredential {
  email: string;
  password: string;
  phone: string;
  name: string;
  firstname: string;
}

export interface ICreateCompany {
  siren: string;
  name: string;
  property_in_management: string;
  type: string;
}

export interface IRight {
  label: string;
  isAuthorized: boolean;
}

export interface IAgency {
  id: string;
  label: string;
  groupeId: string;
  rights: Array<IRight>;
}

export interface IUser {
  id: string;
  email: string;
  lastname: string;
  firstname: string;
  isSuperAdmin: boolean;
  phoneNumber?: string;
  groups: Array<object>;
  agencies: Array<IAgency>;
}

export interface IResponseAuth {
  token: string;
  user: IUser;
}

export interface IUserState {
  id: string;
  lastname: string;
  firstname: string;
  email: string;
  phoneNumber: string;
  role?: string;
  companyId?: string;
  type?: string;
  teamMember?: ITeamMember;
  userInfos: IUserInfos;
  imagePath?: string;
}

export interface IUserInfos {
  id: string;
  activityDone?: IReferential;
  activityTime?: IReferential;
}

export interface ICompanyState {
  id?: string;
  name: string;
  siren: string;
  siret: string;
  property_in_management?: string;
  address: string;
  additionalAddress?: string;
  zip: string;
  city: string;
  type?: string;
}

const initState = {
  isLoading: false,
  isLogged: false,
  user: null,
  token: null,
  appInfo: {
    alert: "",
    version: {
      api: "",
      android: "",
      ios: "",
      referential: "",
    },
  },
  company: null,
};

const authReducer = produce((draft = initState, action: AnyAction) => {
  switch (action.type) {
    case TOGGLE_LOGIN:
      draft.isLoading = true;
      break;
    case TOGGLE_LOGIN_SUCCESS:
      draft.user = action.payload.user;
      draft.token = action.payload.token;
      if (action.payload.appInfo) {
        draft.appInfo = action.payload.appInfo;
      }
      draft.isLogged = true;
      draft.isLoading = false;
      break;
    case TOGGLE_LOGIN_FAILED:
      draft.isLoading = false;
      break;
    case GET_USER_SUCCESS:
      draft.user = {
        id: action.payload.id,
        name: action.payload.name,
        firstname: action.payload.firstname,
        email: action.payload.email,
        phoneNumber: action.payload.phone_number,
        verified_phone_number: action.payload.verified_phone_number,
        companyId: action.payload.society_id,
        teamMember: action.payload.teamMember,
        userInfos: action.payload.userInfos,
        imagePath: action.payload.image_path,
      };
      break;
    case TOGGLE_REGISTER_SUCCESS:
      draft.user = {
        id: action.payload.id,
        name: action.payload.name,
        firstname: action.payload.firstname,
        email: action.payload.email,
        phoneNumber: action.payload.phone,
        verified_phone_number: action.payload.verified_phone_number,
      };
      draft.token = action.payload.token;
      break;
    case TOGGLE_CREATE_COMPANY_SUCCESS:
      draft.user.companyId = action.payload;
      break;
    case TOGGLE_LOGOUT_SUCCESS:
      draft.isLogged = false;
      draft.user = null;
      draft.token = null;
      break;
    case SET_IS_LOGGED_TRUE:
      draft.isLogged = true;
      break;
    case SET_IS_LOGGED_FALSE:
      draft.isLogged = false;
      break;
    case TOKEN_IS_VALID_FAILED:
      draft.isLogged = false;
      draft.user = null;
      draft.token = null;
      draft.company = null;
      break;
    default:
      return draft;
  }
});

export default authReducer;
